import {
  FantazFailure,
  SendUserAttributeVerificationCodeInput,
  UpdateUserAttributeInput,
  VerifiableUserAttributeKey,
} from '@fantaz/shared/data-access/models';
import { createActionGroup, emptyProps } from '@ngrx/store';

// Validate the contact point
export const ContactPointFormActionTypes = createActionGroup({
  source: 'Profile/Contact Point Form',
  events: {
    'Init Verification': (payload: {
      attr: VerifiableUserAttributeKey;
      value: string;
    }) => ({
      ...payload,
    }),

    'Saving Contact Point In Progress': (payload: {
      attr: VerifiableUserAttributeKey;
      value: string;
    }) => ({ ...payload }),

    'Saving Contact Point Success': (payload: {
      attr: VerifiableUserAttributeKey;
      value: string;
    }) => ({ ...payload }),

    'Saving Contact Point Failure': (payload: {
      attr: VerifiableUserAttributeKey;
      value: string;
      error: FantazFailure;
    }) => ({ ...payload }),
  },
});

export const ContactPointActionTypes = createActionGroup({
  source: '[Profile/Contact Point]',
  events: {
    'Add Contact Point In Progress': (payload: {
      attr: VerifiableUserAttributeKey;
      value: string;
    }) => ({ ...payload }),

    'Add Contact Point Success': (payload: {
      attr: VerifiableUserAttributeKey;
      value: string;
    }) => ({ ...payload }),

    'Add Contact Point Failure': (payload: {
      attr: VerifiableUserAttributeKey;
      value: string;
      error: FantazFailure;
    }) => ({ ...payload }),
  },
});

export const ContactPointConfirmVerificationCodeActions = createActionGroup({
  source: 'Profile Contact Point/Confirm Verification Code',
  events: {
    'Confirm Verification Code In Progress': (payload: {
      attr: VerifiableUserAttributeKey;
      value: string;
      code: string;
    }) => ({ ...payload }),

    'Confirm Verification Code Success': (payload: {
      attr: VerifiableUserAttributeKey;
      value: string;
      code: string;
    }) => ({ ...payload }),

    'Confirm Verification Code Failure': (payload: {
      attr: VerifiableUserAttributeKey;
      value: string;
      code: string;
      error: FantazFailure;
    }) => ({ ...payload }),
  },
});

export const ContactPointResendVerifyCodeActionTypes = createActionGroup({
  source: '[Profile/Contact Point Resend Verify Code]',
  events: {
    'Resend Verify Code In Progress': () => emptyProps(),

    'Resend Verify Code Success': (payload: UpdateUserAttributeInput) => ({
      ...payload,
    }),

    'Resend Verify Code Failure': (payload: {
      data: UpdateUserAttributeInput;
      error: any;
    }) => ({ ...payload }),
  },
});
